module.exports = __webpack_public_path__ + "img/icon-autonym@2x.02a2a17a.png";